import { render, staticRenderFns } from "./alldel2.vue?vue&type=template&id=c22d375c&scoped=true&"
import script from "./alldel2.vue?vue&type=script&lang=js&"
export * from "./alldel2.vue?vue&type=script&lang=js&"
import style0 from "./alldel2.vue?vue&type=style&index=0&id=c22d375c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22d375c",
  null
  
)

export default component.exports